import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { IViewPair } from "src/app/interfaces/interfaces";

import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";

@Component({
  selector: "app-dropdown",
  templateUrl: "./dropdown.component.html",
  imports: [ReactiveFormsModule, MatFormField, MatSelect, MatOption, MatLabel],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownComponent {
  data = input.required<IViewPair[]>();
  label = input<string | undefined>();
  formField = input<boolean>(false);
  parentForm = input<FormGroup<any> | undefined>();
  formControlKey = input<string | undefined>();

  constructor() {}
}
